export default {"src":"/_next/static/media/wallet.198fc11a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};